module.exports = __webpack_public_path__ + "static/media/mode-24.a9d0b07c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-24.svg
// module id = 997
// module chunks = 2